// Values match the whatsappMeta.list.status locale keys.
export enum WhatsAppWabaStatus {
    ACTIVE = 'active',
    READY = 'ready',
    AWAITING_ACTIVATION = 'awaitingActivation',
    DISCONNECTED = 'disconnected',
}
